import { createContext, useContext, useEffect, useId } from "react";

export type AppShellState = {
    registerDraft: (id: string, label: string | null) => void;
    runGuarded: (action: () => void) => void;
};

export const AppShellContext = createContext<AppShellState | null>(null);
export const useAppShell = () => useContext(AppShellContext);

/** Protect both route navigation and salon changes while a form has a draft. */
export function useUnsavedChanges(dirty: boolean, label = "Несохранённые изменения") {
    const registerDraft = useAppShell()?.registerDraft;
    const id = useId();
    useEffect(() => {
        registerDraft?.(id, dirty ? label : null);
        return () => registerDraft?.(id, null);
    }, [registerDraft, id, dirty, label]);
}
